export default "__VITE_ASSET__2e979b3b__"